function FAQ() {
  return (
    <section id="HELP&FAQ">
      <span className="section_title">HELP &amp; FAQ</span>

      <div className="faq_section">
        <div className="faq_item">
          <span className="faq_title">Why Polygon?</span>
          <span className="faq_content">
            Funkies is a community centered project, we want users to enjoy the
            advantage of cheap to zero gas fees, lower minting cost and high
            frequency transactions rate available on the Polygon network. Also,
            users can choose to transfer their Funkies to Ethereum as opensea
            provies a swap option for Polygon/Ethereum collectibles or by
            following the link below:
            <br />
            <br />
            https://medium.com/stakingbits/guide-to-transferring-tokens-from-polygon-to-ethereum-bbf8e531c5ff
          </span>
        </div>
        <div className="faq_item">
          <span className="faq_title">
            HOW TO ADD POLYGON Network TO METAMASK?
          </span>
          <span className="faq_content">
            Step 1. Open MetaMask
            <br />
            <br />
            Step 2. Go to settings
            <br />
            <br />
            Step 3. Go to networks
            <br />
            <br />
            Step 4. Click 'Add Network'
            <br />
            <br />
            Fill in the input fields with the following values:
            <br />
            • Network Name: Matic Mainnet
            <br />
            • New RPC URL: https://polygon-rpc.com/
            <br />
            • Chain ID: 137
            <br />
            • Symbol: MATIC
            <br />
            • Block Explorer URL: https://polygonscan.com/
            <br />
            <br />
            Step 5. Click 'Save'
          </span>
        </div>
        <div className="faq_item">
          <span className="faq_title">How To Get MATIC(two ways)?</span>
          <span className="faq_content">
            1: Buy MATIC on a centralized exchange (like Wazirx, Coinbase,
            Binance or Huobi) and transfer it directly to Metamask account.
            <br />
            <br />
            2: Convert your Ether, USDT and others to MATIC on a centralized
            Exchange and transfer it directly to Metamask account
          </span>
        </div>
        <div className="faq_item">
          <span className="faq_title">What is a Funky?</span>
          <span className="faq_content">
            Randomly generated pixel collectibles of various rarity living on
            the Polygon Network as ERC-721 tokens. Funky is set to become part
            of the Polygon/Ethereum Family!
          </span>
        </div>
        <div className="faq_item">
          <span className="faq_title">How do I purchase a Funky?</span>
          <span className="faq_content">
            Funkies will be available for purchase at owners discretion in all
            Polygon/Etheruem supported NFT Marketplace after all are minted!
          </span>
        </div>
        <div className="faq_item">
          <span className="faq_title">When do Funkies launch? </span>
          <span className="faq_content">
            We plan on launching Funkies very soon.
          </span>
        </div>
        <div className="faq_item">
          <span className="faq_title">
            How much will it cost to mint a Funky?
          </span>
          <span className="faq_content">
            It will cost 30 MATIC to mint each of 10,000 available Funkies.
          </span>
        </div>
        <div className="faq_item">
          <span className="faq_title">How many Funkies can I mint?</span>
          <span className="faq_content">
            A maximum of 30 Funkies can be minted per transaction. You can,
            however, execute as many transactions as you like if you really want
            to be the life of the party!!
          </span>
        </div>
      </div>
    </section>
  );
}

export default FAQ;
